import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { PRIORITY_LABELS, PRIORITY_COLORS, STATUS_LABELS, STATUS_COLORS, formatDate } from "@/lib/labels";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { AlertTriangle, Clock } from "lucide-react";

const ageDays = (iso) => Math.floor((Date.now() - new Date(iso).getTime()) / 86400000);

export default function Pendencies() {
  const navigate = useNavigate();
  const [items, setItems] = useState(null);

  useEffect(() => { api.get("/pendencies").then(({ data }) => setItems(data)); }, []);

  if (!items) {
    return <div className="flex items-center justify-center h-64"><div className="h-8 w-8 rounded-full border-2 border-primary border-t-transparent animate-spin" /></div>;
  }

  const critical = items.filter((i) => i.priority === "critica");

  return (
    <div className="space-y-6" data-testid="pendencies-page">
      <div>
        <h1 className="font-heading text-2xl sm:text-3xl font-bold tracking-tight">Pendências</h1>
        <p className="text-sm text-muted-foreground mt-1">
          {items.length} pendência(s) em aberto · {critical.length} crítica(s). Uma pendência permanece aberta até a ocorrência ser concluída.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4">
        {items.map((o) => (
          <Card key={o.id} onClick={() => navigate(`/ocorrencias/${o.id}`)}
            className={`p-4 border-border bg-card cursor-pointer hover:border-primary/50 transition-colors duration-150 ${o.priority === "critica" ? "border-red-500/40" : ""}`}
            data-testid={`pendency-card-${o.protocol}`}>
            <div className="flex items-center justify-between gap-2">
              <span className="font-mono text-xs font-semibold text-primary">{o.protocol}</span>
              <Badge variant="outline" className={PRIORITY_COLORS[o.priority]}>
                {o.priority === "critica" && <AlertTriangle size={11} className="mr-1" />}
                {PRIORITY_LABELS[o.priority]}
              </Badge>
            </div>
            <p className="font-medium text-sm mt-2.5">{o.client_name} · {o.unit_name}</p>
            <p className="text-xs text-muted-foreground mt-0.5">{o.area_name} → {o.subarea_name}</p>
            <p className="text-xs text-muted-foreground mt-2 line-clamp-2">{o.description}</p>
            <div className="flex items-center justify-between mt-3 pt-3 border-t border-border/60">
              <Badge variant="outline" className={STATUS_COLORS[o.status]}>{STATUS_LABELS[o.status]}</Badge>
              <span className="text-[11px] text-muted-foreground flex items-center gap-1">
                <Clock size={11} /> {ageDays(o.created_at)}d em aberto
              </span>
            </div>
          </Card>
        ))}
      </div>
      {items.length === 0 && (
        <Card className="border-border bg-card p-12 text-center text-sm text-muted-foreground">Nenhuma pendência em aberto. Excelente trabalho!</Card>
      )}
    </div>
  );
}
